export enum Screen {
  SEND_MONEY = 0,
  DASHBOARD = 1,
  PLACEHOLDER = 2, // Reserved/unused
  BENEFICIARY_SELECTION = 3,
  ADD_BENEFICIARY = 4,
  PAYMENT_CONFIRMATION = 5,
  RECIPIENT_SELECTION = 6, // Can also show SavedBeneficiariesScreen
  BANK_DETAILS = 7,
  UPLOAD_PAYMENT_DETAILS = 8,
  EMAIL_RECIPIENT = 9,
  REVIEW_DETAILS = 10,
  PAYMENT_STATUS = 11,
  PAYMENT_LIST = 12,
  PAYMENT_DETAILS = 13,
  BENEFICIARY_METADATA = 14,
  BENEFICIARIES_MANAGEMENT = 15,
  BENEFICIARY_EDIT = 16,
  BENEFICIARY_VIEW = 17,
  SETTINGS = 18,
  SUPPORT_TICKET = 20,
  PERSONAL_INFO_MANAGEMENT = 21,
}
